
import React, { useState, useEffect } from "react";
import { Formik } from 'formik';
import { object, string, ref } from 'yup';
import { isEmpty } from 'lodash';
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { AiFillEyeInvisible, AiFillEye } from "react-icons/ai";
import { useNavigate } from "react-router-dom";

import Header from "../../header/header";
import LabelInput from "../../uiComponent/inputs/labelInput";
import Button from "../../uiComponent/button/index";

import { AuthWrapper } from "../style";

import { ResetPassword } from "../../../slices/auth";

const SignIn = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { resetPasswordLoading } = useSelector(state => state?.auth || {});
  const [passwordShow, setPasswordShow] = useState(true);
  const [confirmPasswordShow, setConfirmPasswordShow] = useState(true);

  const savePassword = async (values) => {

    const { password, confirmPassword } = values;
    const query = new URLSearchParams(window.location.search);
    const reset_password_token = query.get('reset_password_token')

    if (isEmpty(reset_password_token)) {
      navigate('/auth/password-email-verification');
      return;
    };

    const user = {
      token: reset_password_token,
      password: password,
    }

    const response = await dispatch(ResetPassword({ ...user }));
    if (!response.error) {
      // Store completion data for other tabs
      const completionData = {
        timestamp: Date.now().toString(),
        token: reset_password_token,
        passwordChanged: true
      };
      localStorage.setItem("passwordChangeCompleted", JSON.stringify(completionData));
      navigate('/auth/sign-in');
    }
  }

  const handleSetPassword = () => {
    setPasswordShow(!passwordShow);
  };

  const handleSetConfirmPassword = () => {
    setConfirmPasswordShow(!confirmPasswordShow);
  };

  // Listen for completion from other tabs
  useEffect(() => {
    const handleStorageEvent = (e) => {
      if (e.key === "passwordChangeCompleted" && e.newValue) {
        try {
          const completionData = JSON.parse(e.newValue);
          if (completionData.passwordChanged && window.location.href.includes("/password-change")) {
            localStorage.removeItem("passwordChangeCompleted");
            navigate('/auth/sign-in');
          }
        } catch (error) {
          console.error("Error parsing completion data:", error);
        }
      }
    };

    window.addEventListener("storage", handleStorageEvent);
    return () => {
      window.removeEventListener("storage", handleStorageEvent);
    };
  }, [navigate]);

  const schema = object().shape({
    password: string()
      .required('Please Enter your password')
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{12,})/,
        "Must Contain 12 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      ),
    confirmPassword: string()
      .required('Confirm Password is required')
      .oneOf([ref("password"), null], "Passwords must match")
  });

  return (
    <AuthWrapper>
      <Formik
        validationSchema={schema}
        onSubmit={(values) => savePassword(values)}
        initialValues={{
          password: '',
          confirmPassword: ''
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          errors,
          touched
        }) => (
          <Form onSubmit={handleSubmit}>
            <Header login={true} />
            <div className="auth-container-overlay-wrapper">
              <div className="auth-container">
                <div className="bg-albaster auth-password-change">
                  <div className="mb-35">
                    <h2>Enter New Password</h2>
                  </div>
                  <div className="password-input">
                    <LabelInput
                      inputStatus={touched.password && errors.password}
                      name='password'
                      label="New Password"
                      type={passwordShow ? "password" : "text"}
                      placeholder="Password"
                      value={values.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {passwordShow ? (
                      <AiFillEyeInvisible onClick={handleSetPassword} />
                    ) : (
                      <AiFillEye onClick={handleSetPassword} />
                    )}
                  </div>
                  <div className="password-input">
                    <LabelInput
                      inputStatus={touched.confirmPassword && errors.confirmPassword}
                      name='confirmPassword'
                      label="Confirm Password"
                      type={confirmPasswordShow ? "password" : "text"}
                      placeholder="Password"
                      value={values.confirmPassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {confirmPasswordShow ? (
                      <AiFillEyeInvisible onClick={handleSetConfirmPassword} />
                    ) : (
                      <AiFillEye onClick={handleSetConfirmPassword} />
                    )}
                  </div>
                  <div className="mt-40">
                    <Button
                      type="submit"
                      disabled={resetPasswordLoading}
                      text={resetPasswordLoading ? "Saving new password..." : "Save New Password"}
                      className="primary w-100"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </AuthWrapper>
  );
};

export default SignIn;
